// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Package/components/VideoPlayer/index.css
// module id = 2283
// module chunks = 0